import { render, staticRenderFns } from "./AlgoliaNavSearch.vue?vue&type=template&id=186b22c4"
import script from "./AlgoliaNavSearch.vue?vue&type=script&lang=js"
export * from "./AlgoliaNavSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports